<template>
  <h6>Redireccionando...</h6>
</template>

<script>
export default {
    async mounted() {
        this.$router.push({ name: "Lesson"})
    }
}
</script>

<style>

</style>